var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-120 -460)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bg",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(120 460)",
    fill: "#263a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M61.767,26.8C55.707,12.73,44.307,4,32.007,4s-23.7,8.73-29.76,22.8a3,3,0,0,0,0,2.4C8.307,43.27,19.707,52,32.007,52s23.7-8.73,29.76-22.8A3,3,0,0,0,61.767,26.8ZM32.007,46c-9.51,0-18.51-6.87-23.7-18,5.19-11.13,14.19-18,23.7-18s18.51,6.87,23.7,18C50.517,39.13,41.517,46,32.007,46Zm0-30a12,12,0,1,0,12,12A12,12,0,0,0,32.007,16Zm0,18a6,6,0,1,1,6-6A6,6,0,0,1,32.007,34Z",
    transform: "translate(140.003 484)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.871c5bac55a52ae60e0593c78f1c7bd7.svg";
export { ForwardRef as ReactComponent };